module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/personalize-events-2018-03-22.paginators.json
// module id = 985
// module chunks = 3